import React from "react";
import homeBannerVideo from "../../images/home/homepage.webm";

const Cube = () => {
  return (
    <>
      <video
        style={{ width: "76%" }}
        playsInline
        loop={true}
        muted
        autoPlay={true}
        src={homeBannerVideo}
      >
        <track kind="captions" src="" />
      </video>
    </>
  );
};

export default Cube;
